import { Checkbox } from "antd"
import { memo } from "react"
import { ColumnGroup } from "./types"

export const ColumnVisibilityGroup = memo(function ColumnVisibilityGroup({
  group,
  hiddenColumnKeys,
  visibleLeafCount,
  onToggleGroup,
  onToggleLeaf,
}: {
  group: ColumnGroup
  hiddenColumnKeys: string[]
  visibleLeafCount: number
  onToggleGroup: () => void
  onToggleLeaf: (leafKey: string) => void
}) {
  const visibleLeaves = group.leaves.filter(
    (leaf) => !hiddenColumnKeys.includes(leaf.key)
  )
  const isGroupVisible = visibleLeaves.length > 0
  const isGroupIndeterminate =
    visibleLeaves.length > 0 && visibleLeaves.length < group.leaves.length

  return (
    <div className="rounded-md border border-neutral40 p-2">
      <Checkbox
        checked={isGroupVisible}
        indeterminate={isGroupIndeterminate}
        onChange={onToggleGroup}
        disabled={isGroupVisible && visibleLeafCount === group.leaves.length}
      >
        <span className="text-sm font-semibold text-neutral600">
          {group.title}
        </span>
      </Checkbox>
      {group.leaves.length > 1 && (
        <div className="mt-2 flex flex-col gap-2 pl-6">
          {group.leaves.map((leaf) => {
            const isVisible = !hiddenColumnKeys.includes(leaf.key)
            return (
              <Checkbox
                key={leaf.key}
                checked={isVisible}
                onChange={() => onToggleLeaf(leaf.key)}
                disabled={isVisible && visibleLeafCount === 1}
              >
                <span className="text-sm text-neutral500">{leaf.title}</span>
              </Checkbox>
            )
          })}
        </div>
      )}
    </div>
  )
})
